export const cloud_url = 'https://test-dot-gym-bro-101ca.ew.r.appspot.com';
// export const cloud_url = 'http://127.0.0.1:8080'
// const cloud_url = 'http://127.0.0.1:5000'